import { get, post } from "./http";
export const login = params =>
    post("/userService/Account/LoginForBackStage", params);
export const GenToken = params =>
    post("/tokenService/Token/GenToken", params);
// 广告管理
export const bannerList = params => post("/Banner/BannerManage/SelectBannerByCondition", params);
// 新增广告
export const addBanner = params => post("/Banner/BannerManage/InsertBanner", params);
// 编辑广告
export const checkBanner = params => post("/Banner/BannerManage/UpdateBanner", params);
export const delBanner = params =>
    post("/Banner/BannerManage/DeleteBannerById", params);
export const getkind = params =>post("/bdService/BaseData/SelectBaseData", params);
// 平台公告
export const messageList = params =>
    post("/Message/MessageManage/SelectMessageByCondition", params);
export const addMessage = params =>
    post("/Message/MessageManage/InsertMessage", params);
export const checkMessage = params =>
    post("/Message/MessageManage/UpdateMessage", params);
export const topMessage = params =>
    post("/Message/MessageManage/UpdateIsTop", params);
// 订单管理
export const orderList = params =>
    post("order/ordermanage/SelectOrderByCondition", params);
//订单管理导出
export const orderListdao = params =>
    post("order/ordermanage/ExportToExcel", params);
// 审核状态

export const changestatus = params =>
    post("bdService/BaseData/SelectStutasBaseData", params);
//退单管理审核
export const tuidanshen = params =>
    post("order/AfterSaleManage/UpdateAfterSale", params);
// 查看订单
export const seeorder = params =>
    post("order/ordermanage/GetOrderById", params);


// 订单查询物流，编辑物流
export const viewExpress = params =>
    post('order/ordermanage/GetOrderLogistics', params);
export const editExpress = params =>
    post('order/ordermanage/GetOrderLogistics', params);
// 订单管理编辑
export const subOrder = params => post('order/ordermanage/EditOrderLogistics', params)
    // 订单取消
export const cancleOrder = params => post('order/ordermanage/LaunchCancelOrderByOrderDetailId', params)
    //退单管理
export const tuidanlist = params =>
    post("/order/AfterSaleManage/SelectAfterSaleByCondition", params);
//订单管理售后申请
export const shouhousale = params =>
    post("/Order/AfterSaleManage/Applicationforaftersale", params);
//退单管理导出

export const daotuidanlist = params =>
    post("/order/AfterSaleManage/ExportToExcel", params);
//查询结算
export const jiesuan = params =>
    post("/SettlementManage/SelectSettlement", params);
//发票管理
export const fapiao = params =>
    post("/order/OrderTicketManage/SelectOrderTicketByCondition", params);

//编辑发票
export const editfapiao = params =>
    post("/order/OrderTicketManage/EditOrderTicket", params);
//查看发票
export const seefapai = params =>
    post("/order/OrderTicketManage/GetOrderTicketById", params);

//票据审核
export const piaoju = params =>
    post("/order/OrderGoodsBillManage/SelectOrderGoodsBillByCondition", params);
//审核票据
export const shenpiaoju = params =>
    post("order/OrderGoodsBillManage/UpdateOrderGoodsBill", params);
// 查看票据
export const chapiaoju = params =>
    post("/order/OrderGoodsBillManage/GetSingleOrderGoodsBill", params);


//提现审核
export const tixianshen = params =>
    post("/order/WithdrawalManage/SelectWithdrawalByCondition", params);
//确定提现审核
export const quetixianshen = params =>
    post("/order/WithdrawalManage/UpdateWithdrawal", params);

//优惠券
export const couponlist = params =>
    post("/Coupon/CouponManage/SelectCouponByCondition", params);


//商品列表
export const goodslist = params =>
    post("/goodsService/Goods/SelectGoodsByCondtionForBack", params);
//查询商品信息
export const chagoodinfo = params =>
    post("/goodsService/Goods/SelectGoodsInfoByGoodsId", params);
//设置首页和今日推荐
export const hometui = params =>
    post("/goodsService/Goods/SetGoodsShowStyle", params);
//新增尾贷管理商品
export const addweidai = params =>
    post("/goodsService/TailCargo/InsertTailCargo", params);
//新增样品管理
export const addyangpin = params =>
    post("/goodsService/Sample/InsertSample", params);
//新增特卖
export const addtemai = params =>
    post("/goodsService/SpecialSale/InsertSpecialSale", params);
//新增团购
export const tuangou = params =>
    post("/goodsService/GroupBuy/InsertGroupBuy", params);
//新增预售
export const yushou = params =>
    post("/goodsService/AdvanceSale/InsertAdvanceSale", params);
//新增vip
export const addvip = params =>
    post("/goodsService/VipGoods/InsertVipGoods", params);
//修改商品信息
export const changegood = params =>
    post("/goodsService/Goods/UpdateGoodsStatusByGoodsId", params);
//查询商品参数
export const goodinfo = params =>
    post("/goodsService/Goods/SelectGoodsParamsByGoodsTypeIdAndGoodsId", params);

//根据品类获取区域
export const getquyu = params =>
    post("/goodsService/Goods/SelectGoodsParamsByGoodsTypeIdAndGoodsId", params);
//合作类型  根据城市查询品牌商
export const gethezuo = params =>
    post("/userService/BrandBusiness/SelectBrandBusinessCooperationByCityId", params);


/**
 *评论管理
 * */
export const pinglun = params =>
    post("/goodsService/GoodsReview/SelectGoodReviewByCondition", params);
// 查询商品评论
export const productPinglun = params =>
    post("/goodsService/GoodsReview/SelectReviewByGoodsId", params);
//删除评论
export const deletepinglun = params =>
    post("/goodsService/GoodsReview/DeleteReview", params);


// 评论关键字统计
export const guanjianzi = params =>
    post('/goodsService/GoodsReview/SelectGoodsKeyWordByBrandType', params)
    //查询尾贷管理
export const weidailist = params =>
    post("/goodsService/TailCargo/SelectTailCargoByCondtion", params);
//查询样品管理
export const yangpinlist = params =>
    post("/goodsService/Sample/SelectSampleModelByCondtion", params);
//查询特卖管理
export const temailist = params =>
    post("/goodsService/SpecialSale/SelectSpecialSaleByCondtion", params);
//预售管理
export const yushoulist = params =>
    post("/goodsService/AdvanceSale/SelectAdvanceSaleByCondtion", params);
//vip管理
export const viplist = params =>
    post("/goodsService/VipGoods/SelectVipGoodsByCondtion", params);

//用户管理
export const userlist = params =>
    post("/userService/UserManage/SelectUserManage", params);
//共创端管理
export const togetherlist = params =>
    post("/userService/CoCreationEnderManage/SelectCoCreationEnderManage", params);
//平台管家管理
export const butlerlist = params =>
    post("/userService/HousekeeperManage/SelectHousekeeperManage", params);
// 品牌商管理
export const brandlist = params =>
    post("/userService/BrandBusiness/SelectBrandBusinessByCondition", params);
//佣金设置
export const yongjin = params =>
    post("/userService/BrandBusiness/UpdateBrandBusinessPriceRate", params);
// 新增品牌商
export const addbrand = params =>
    post("/userService/BrandBusiness/InsertBrandBusiness", params);

//修改品牌商
export const updatebrand = params =>
    post("/userService/BrandBusiness/UpdateBrandBusiness", params);
//更改状态
export const updatestatus = params =>
    post("/userService/BrandBusiness/UpdateBrandBusinessStatus", params);


//适用品类
export const shiyongpinlei = params =>
    post("/bdService/BaseData/SelectGoodsBrandTypeByActiveAndGoods", params);
//审核优惠券
export const shenhecoupon = params =>
    post("/Coupon/CouponManage/AuditCoupon", params);
//新增优惠券选择商品

export const selectgoods = params =>
    post("/Coupon/CouponManage/SelectGoodForCoupon", params);

export const addCoupon = params =>
    post('/Coupon/CouponManage/AddCoupon', params);
// 根据id获取优惠券详情
export const getCoupondetail = params =>
    post('/Coupon/CouponManage/SelectCouponById', params);
// 编辑优惠券
export const editcoupon = params =>
    post('/Coupon/CouponManage/EditCoupon', params);

// 问答管理
export const question = params => post("/QuestionsManage/SelectQuestionByCondition", params);
// 查询回复
export const huifu = params => post("/Questions/QuestionsManage/SelectAnswerByQuestion", params);
// 获取问题详情
export const quesdetail = params => post("/Questions/QuestionsManage/SelectQuestionsById", params);
// 设置精华
export const shejinghua = params => post("/Questions/QuestionsManage/SetEssence", params);
// 删除回复
export const shanchuhuifu = params => post("/Questions/QuestionsManage/DeleteAnswer", params);
// 问答管理设置状态
export const wendastate = params => post("/Questions/QuestionsManage/UpdateStatus", params);
// 单个删除
export const getRemoveQuestionById = params => post("/Questions/QuestionsManage/RemoveQuestionById", params);

// 内容管理
export const content = params =>
    post("/contentService/Content/SelectContent", params);
//新增内容
export const insertcontent = params =>
    post("/contentService/Content/InsertContent", params);
//修改内容
export const xiugaicontent = params =>
    post("/contentService/Content/UpdateContent", params);
//获取内容详情
export const contentdetail = params =>
    post("/contentService/Content/SelectContentById", params);

//淘专动态
export const taodongtai = params =>
    post("/contentService/News/SelectNews", params);
//新增淘专动态
export const inserttaobao = params =>
    post("/contentService/News/InsertNews", params);
//获取淘专详情
export const gettaodetail = params =>
    post("/contentService/News/SelectNewsById", params);

//修改新闻动态
export const xiugainews = params =>
    post("/contentService/News/UpdateNews", params);
//删除淘专动态

export const deleteNews = params =>
    post("/contentService/News/DeleteNews", params);

//财富管理

export const getcaifu = params =>
    post("/contentService/FortuneCollege/SelectFortuneCollege", params);
//新增财富管理

export const addcaifu = params =>
    post("/contentService/FortuneCollege/InsertFortuneCollege", params);
//编辑财富管理
export const editcaifu = params =>
    post("/contentService/FortuneCollege/UpdateFortuneCollege", params);
//删除财富管理
export const deletecaifu = params =>
    post("/contentService/FortuneCollege/DeleteFortuneCollege", params);
//查询财富学院
export const caifudetail = params =>
    post("/contentService/FortuneCollege/SelectFortuneCollegeId", params);


//预约服务
export const yuyue = params =>
    post(
        "/customerServerService/ReservationConsultation/SelectReservationConsultation",
        params
    );

//跟催单

export const gencui = params =>
    post(
        "/customerServerService/ReservationConsultation/SendSMSReservationConsultation",
        params
    );
//编辑预约服务

export const edityuyue = params =>
    post(
        "/customerServerService/ReservationConsultation/UpdateReservationConsultation",
        params
    );
//审核预约服务

export const shenheyuyue = params =>
    post(
        "/customerServerService/PriceComplaint/UpdatePriceComplaint",
        params
    );
//查询预约服务
export const chayuyue = params =>
    post("/customerServerService/ReservationConsultation/SelectReservationConsultationById", params);

//价格投诉
export const tousu = params =>
    post("/customerServerService/PriceComplaint/SelectPriceComplaint", params);
//根据条件查询角色
export const juese = params =>
    post("/roleService/Role/SelectRoleByCondition", params);
//查询员工列表
export const yuangonglist = params =>
    post("/userService/Staff/SelectStaff", params);

// 新增员工信息
export const addyuangong = params =>
    post("/userService/Staff/InsertStaffUser", params);

//员工所属机构
export const yuangongjigou = params =>
    post("/userService/BrandBusiness/SelectBrandBusiness", params);
//根据id查询员工
export const chayuangong = params =>
    post("/userService/Staff/SelectStaffByUserId", params);
// 角色管理
export const rolelist = params => post("/roleService/Role/SelectRole", params);
//新增角色
export const insertrole = params => post("/roleService/Role/InsertRole", params);
//修改角色
export const updaterole = params => post("/roleService/Role/UpdateRole", params);

// 通过角色获取菜单模块
export const getMenus = params => post('/roleService/Role/SelectAllFunctionByRoleId', params);
// 通过角色获取权限
export const aleradyChoose = params => post('/roleService/Role/SelectFuncByRoleId', params);
//日志管理
export const systemlist = params =>
    post("/bdService/BaseData/SelectOperationLog", params);

/****
 * 系统管理
 * ** */

// 获取角色列表
export const userServiceList = params => post('/userService/Staff/SelectRolesByUserId', params);
// 分配员工角色
export const comfirmUserRole = params => post('/userService/Staff/UpdateUserRoleByUserId', params);
// 修改员工角色
export const editUserRole = params => post('/userService/Staff/UpdateStaffByUserId', params);
// 权限设置
export const setTingAuth = params => post('/roleService/Role/UpdateRoleFuncByRoleId', params);
// 获取菜单
export const asideMenu = params => post('/userService/Staff/SelectFuncByUserId', params);
//根据Id查询品牌商信息
export const byIdfindinfo1 = params =>post("/userService/BrandBusiness/SelectBrandBusinessById",params)
//修改密码验证码
export const codenum = params =>post("/userService/Account/InsertVerificationCode",params)
//修改密码
export const ChangePassword = params =>post("/userService/Staff/UpdateStaffPassword",params)
//结算管理编辑
export const jeisuanbianji = params =>post("/Order/SettlementManage/UpdateSettlement",params)
//根据条件查询代理品牌
export const pinpaishang = params =>post("/userService/BrandBusiness/SelectAgentBrandByCondition",params)
//根据条件查询代理品牌
export const chongzhimima = params =>post("/userService/Staff/ResetLoginPwd",params)
//查找市区
export const findCity = params =>post("/bdService/BaseData/SelectOpenAddressTree",params)

//查询砍价商品配置列表
export const BargainGoods = params =>post("/BargainManage/BargainManage/SelectAddBargainGoods",params)
//新增砍价商品
export const InsertBargainGoods = params =>post("/BargainManage/BargainManage/InsertBargainGoods",params)
//查询砍价商品配置列表
export const SettingList = params =>post("/BargainManage/BargainManage/SelectBargainGoodsSettingList",params)
//上架
export const UpperShelf = params =>post("/BargainManage/BargainManage/UpperShelf",params)
//根据id查询砍价活动商品信息
export const BargainGoodsById = params =>post("/BargainManage/BargainManage/SelectBargainGoodsById",params)
// 配置砍价活动商品
export const SettingBargainGoods = params =>post("/BargainManage/BargainManage/SettingBargainGoods",params)
//强制下架
export const LowerShelf = params =>post("/BargainManage/BargainManage/LowerShelf",params)
//查询商品库存流水记录
export const SelectGoodsStockFlowByGoodsId = params =>post("/Goods/SelectGoodsStockFlowByGoodsId",params)
//查询后台询价列表
export const SelectBiddingInfoByCondition = params =>post("/BiddingManagement/BiddingMerchants/SelectBiddingInfoByCondition",params)
//根据Id查询低价详情
// export const SelectBiddingDetailById = params =>post("/BiddingManagement/BiddingMerchants/SelectBiddingDetailById",params)
//驳回
export const ResfuseBidding = params =>post("/BiddingManagement/BiddingMerchants/ResfuseBidding",params)
//询底价保存
export const MerchantsBiddingOperato = params =>post("/BiddingManagement/BiddingMerchants/MerchantsBiddingOperato",params)

//提交报价
export const MerchantsSubmitBidding = params =>post("/BiddingManagement/BiddingMerchants/MerchantsSubmitBidding",params)
//根据首字母以及其他条件查询品牌或品类
export const SelectBrandAndTypeByFirstLetterAndCondition = params =>post("/bdService/BaseData/SelectBrandAndTypeByFirstLetterAndCondition",params)
//提交审核
export const UpdateBrandBusinessState = params =>post("/userService/BrandBusiness/UpdateBrandBusinessState",params)
//删除
export const DeleteBrandBusiness = params =>post("/userService/BrandBusiness/DeleteBrandBusiness",params)
//获取公众号二维码
export const GetWXPublicAddressOpenIdQRCode = params =>post("userService/Staff/GetWXPublicAddressOpenIdQRCode",params)
//商家报价
export const SelectBiddingListByCondition = params =>post("/BiddingManagement/BiddingManage/SelectBiddingListByCondition",params)
//询价管理根据ID查看详情
export const SelectBiddingDetailById = params =>post("/BiddingManagement/BiddingManage/SelectBiddingDetailById",params)
//提交商家报价
export const InsertBiddingMerchants = params =>post("/BiddingManagement/BiddingManage/InsertBiddingMerchants",params)
//根据Id查看报价详情
export const SelectQuoteMerchantsById = params =>post("BiddingManagement/BiddingManage/SelectQuoteMerchantsById",params)
//删除商家报价
export const DeleteBiddingMerchants = params =>post("/BiddingManagement/BiddingManage/DeleteBiddingMerchants",params)
//驳回
export const RejectBidding = params =>post("BiddingManagement/BiddingManage/RejectBidding",params)
//平台报价列表页
export const SelectBiddingMerchantsListByCondition = params =>post("/BiddingManagement/BiddingManage/SelectBiddingMerchantsListByCondition",params)
//询价订单列表
export const SelectBiddingOrderListByCondition = params =>post("/BiddingManagement/BiddingManage/SelectBiddingOrderListByCondition",params)
//添加物流
export const UpdateBIddingLogistics = params =>post("/BiddingManagement/BiddingManage/UpdateBIddingLogistics",params)
//评论
export const SelectBIddingCommentsByBiddingId = params =>post("/BiddingManagement/BiddingManage/SelectBIddingCommentsByBiddingId",params)
//回复
export const UpdateBiddingCommentsReply = params =>post("/BiddingManagement/BiddingManage/UpdateBiddingCommentsReply",params)
//评论管理
export const UpdateBiddingComments = params =>post("/BiddingManagement/BiddingManage/UpdateBiddingComments",params)
//根据商品名称商品型号查询商品
export const SelectGoodsByNameOrGoodsCode = params =>post("/BiddingManagement/BiddingManage/SelectGoodsByNameOrGoodsCode",params)
//投诉管理列表
export const SelectBiddingComplaintList = params =>post("/BiddingManagement/BiddingManage/SelectBiddingComplaintList",params)
//查询投诉详情页
export const SelectBiddingComplaintById = params =>post("/BiddingManagement/BiddingManage/SelectBiddingComplaintById",params)
//提交驳回
export const UpdateComplaintsProcessing = params =>post("/BiddingManagement/BiddingManage/UpdateComplaintsProcessing",params)
//查寻线下优惠券
export const SelectUnderCouponByCondtion = params =>post("/UnderCouponService/UnderCoupon/SelectUnderCouponByCondtion",params)   
//根据当前用户查询用户能查询的省市数据
export const getSelectProviceAndCityByUserId = params =>post("UnderCouponService/UnderCoupon/SelectProviceAndCityByUserId",params)
//新增线下优惠券  
export const InsertUnderCoupon = params =>post("/UnderCouponService/UnderCoupon/InsertUnderCoupon",params) 
//根据线下优惠券ID，查询优惠券详情
export const SelectUnderCouponInfoById = params =>post("/UnderCouponService/UnderCoupon/SelectUnderCouponInfoById",params) 
//优惠券下架
export const LowerUnderCouponById = params =>post("/UnderCouponService/UnderCoupon/LowerUnderCouponById",params) 
//查询平台核销统计
export const SelectPStatisticsByCondtion = params =>post("UnderCouponService/UnderCoupon/SelectPStatisticsByCondtion",params) 
// 查看平台优惠券核销明细
export const SelectPStatisticsDetailById = params =>post("/UnderCouponService/UnderCoupon/SelectPStatisticsDetailById",params) 
//
export const SelectBStatisticsByCondtion = params =>post("/UnderCouponService/UnderCoupon/SelectBStatisticsByCondtion",params) 
//
export const SelectBStatisticsDetailById = params =>post("/UnderCouponService/UnderCoupon/SelectBStatisticsDetailById",params)
//新商家报价列表查询
export const SelectBiddingListForMerchantsByCondition = params =>post("/BiddingManagement/BiddingManage/SelectBiddingListForMerchantsByCondition",params)
//查询商家打款详情
export const SelectBiddingCommssionInfo = params =>post("/BiddingManagement/BiddingManage/SelectBiddingCommssionInfo",params)
//商家打款完成，点击确认按钮确认完成打款
export const UpdateBiddingMerchantsFarmState = params =>post("/BiddingManagement/BiddingManage/UpdateBiddingMerchantsFarmState",params)
//平台确认收款，并给询价单所属平台管家支付佣金
export const PlatConfirmCommission = params =>post("/BiddingManagement/BiddingManage/PlatConfirmCommission",params)
//新增商家报价，新增设计师佣金字段
export const InsertBiddingMerchantsForGen_Three = params =>post("/BiddingManagement/BiddingManage/InsertBiddingMerchantsForGen_Three",params)
//校验询价单是否发起报价
export const VertifyBiddingEndLine = params =>post("/BiddingManagement/BiddingManage/VertifyBiddingEnable",params)
//报价查询品类
export const SelectGoodsBrandTypeByFirstLetter = params =>post("/bdService/BaseData/SelectGoodsBrandTypeByFirstLetter",params)
//经销商店铺基础信息管理
export const EditBBBaseInfo = params =>post("/ExploreShop/ExploreShop/EditBBBaseInfo",params)

//上传店铺轮播照片
export const UploadFileForExploreShop = params =>post("/ExploreShop/ExploreShop/UploadFileForExploreShop",params)
//经销商店铺地理位置信息管理
// export const EditBBBaseInfo = params =>post("/ExploreShop/ExploreShop/EditBBBaseInfo",params)
//经销商店铺橱窗商品列表查询
export const SelectBBWindowGoodsList = params =>post("/ExploreShop/ExploreShop/SelectBBWindowGoodsList",params)
//查询客户探底价列表
export const SelectCustomerForLowestPricList = params =>post("/ExploreShop/ExploreShop/SelectCustomerForLowestPricList",params)
//查询客户探底价详情页
export const SelectCustomerForLowestPricDetailById = params =>post("/ExploreShop/ExploreShop/SelectCustomerForLowestPricDetailById",params)
//支付获取探底价客户手机号
export const UpdateBBPayForCustomerInformation = params =>post("/ExploreShop/ExploreShop/UpdateBBPayForCustomerInformation",params)
//查询客户探底价跟进/预约到店跟进列表
export const SelectBBShopFollowUpList = params =>post("/ExploreShop/ExploreShop/SelectBBShopFollowUpList",params)
//新增 探底价/预约到店/ 跟进记录 修改完成成交记录
export const InsertBBShopFollowUp = params =>post("/ExploreShop/ExploreShop/InsertBBShopFollowUp",params)
//查询预约到店列表
export const SelectBBReservationList = params =>post("/ExploreShop/ExploreShop/SelectBBReservationList",params)
//经销商店铺 开店/闭店 认证店铺/取消认证店铺 商品 上架/下架 管理
export const EditBBShopIsOpenAndIsCertificate = params =>post("/ExploreShop/ExploreShop/EditBBShopIsOpenAndIsCertificate",params)
//评论列表查询
export const SelectMerchantsCommentsList = params =>post("/ExploreShop/ExploreShop/SelectMerchantsCommentsList",params)
//删除评论
export const DeleteMerchantsComments = params =>post("/ExploreShop/ExploreShop/DeleteMerchantsComments",params)
//经销商根据品类品牌查询站内商品列表
export const SelectGoodsModelByBrandIdAndBrandTypeId = params =>post("/ExploreShop/ExploreShop/SelectGoodsModelByBrandIdAndBrandTypeId",params)
//经销商店铺详情查询
export const SelectBBShopDetailById = params =>post("/ExploreShop/ExploreShop/SelectBBShopDetailById",params)

//查询设计师列表
export const SelectDesignerList = params =>post("/ExploreDecorations/ExploreDecorations/SelectDesignerList",params)
//上架/下架设计师，上架/下架设计师案例，认证/取消认证设计师 设计师完工
export const EditDesignerIsOnlineOrIsCertificatedOrCompleteByOperType = params =>post("/ExploreDecorations/ExploreDecorations/EditDesignerIsOnlineOrIsCertificatedOrCompleteByOperType",params)
//查询设计师详情信息
export const SelectDesignerDecorationDetailById = params =>post("/ExploreDecorations/ExploreDecorations/SelectDesignerDecorationDetailById",params)
//编辑设计师信息
export const EditDesignerBaseInfo = params =>post("/ExploreDecorations/ExploreDecorations/EditDesignerBaseInfo",params)
//查询设计师案例列表
export const SelectDesignerCaseList = params =>post("/ExploreDecorations/ExploreDecorations/SelectDesignerCaseList",params)
//编辑设计师案例信息
export const EditDesignerDecorationCase = params =>post("/ExploreDecorations/ExploreDecorations/EditDesignerDecorationCase",params)
//查询设计师案例详情
export const SelectDesignerCaseDetailById = params =>post("/ExploreDecorations/ExploreDecorations/SelectDesignerCaseDetailById",params)
//查询预约列表
export const SelectDesignerReservationList = params =>post("/ExploreDecorations/ExploreDecorations/SelectDesignerReservationList",params)
//查询设计师擅长空间基础数据信息
export const SelectDesignerSkilledDoMainBaseData = params =>post("/ExploreDecorations/ExploreDecorations/SelectDesignerSkilledDoMainBaseData",params)
//富文本上传图片
export const UploadImg = params =>post("/ExploreShop/ExploreShop/UploadImg",params)
//查询装修公司列表
export const SelectDCList = params =>post("/ExploreDecorations/ExploreDecrationCompany/SelectDCList",params)
//修改店铺管理员账号信息
export const UpdateDCAccount = params =>post("/ExploreDecorations/ExploreDecrationCompany/UpdateDCAccount",params)
//新增装修公司扩展信息，新增成功后，给管理员发送短信通知
export const InsertDCExtendInfo = params =>post("/ExploreDecorations/ExploreDecrationCompany/InsertDCExtendInfo",params)
//新增/修改装修公司基础信息
export const EditDCBaseInfo = params =>post("/ExploreDecorations/ExploreDecrationCompany/EditDCBaseInfo",params)
//上传装修公司图片
export const UpoadImg = params =>post("/ExploreDecorations/ExploreDecrationCompany/UpoadImg",params)
//查询装修公司基本信息详情
export const SelectDCDetailById = params =>post("/ExploreDecorations/ExploreDecrationCompany/SelectDCDetailById",params)
export const EditDCShopImgInfo = params =>post("/ExploreDecorations/ExploreDecrationCompany/EditDCShopImgInfo",params)
// /修改装修公司扩展信息
export const UpdateDCExtendInfo = params =>post("/ExploreDecorations/ExploreDecrationCompany/UpdateDCExtendInfo",params)
//编辑店铺上下架信息
export const UpdateDCStatus = params =>post("/ExploreDecorations/ExploreDecrationCompany/UpdateDCStatus",params)
// /审核入驻信息
export const ReviewDCApply = params =>post("/ExploreDecorations/ExploreDecrationCompany/ReviewDCApply",params)
//根据当前登陆人ID和装修公司名称查询装修公司
export const SelectDCByUserIdAndDcName = params =>post("/ExploreDecorations/ExploreDecorations/SelectDCByUserIdAndDcName",params)
//检查设计师手机号是否存在
export const CheckDeginerPhoneIsExsist = params =>post("/ExploreDecorations/ExploreDecorations/CheckDeginerPhoneIsExsist",params)
//新增设计师基础信息
export const InsertDesignerBaseData = params =>post("/ExploreDecorations/ExploreDecorations/InsertDesignerBaseData",params)
//查询装修公司及公司下设计师列表
export const SelectDCAndDesignerList = params =>post("/ExploreDecorations/ExploreDecrationCompany/SelectDCAndDesignerList",params)
//分配设计师
export const DistributionDesigner = params =>post("/ExploreDecorations/ExploreDecrationCompany/DistributionDesigner",params)
//设置商品销量
export const UpdateGoodsSalesCount = params =>post("/goodsService/Goods/UpdateGoodsSalesCount",params)
//查询商品颜色列表
export const SelectTempGoodsColor = params =>post("/goodsService/Goods/SelectTempGoodsColor",params)
// /查询商品内测评论列表
export const SelectTempGoodsComments = params =>post("/goodsService/Goods/SelectTempGoodsComments",params)
//新增内测商品评论
export const InsertTempGoodsReview = params =>post("/goodsService/Goods/InsertTempGoodsReview",params)
//查询会员卡列表
export const SelectVIPList = params =>post("/VIP/VIP/SelectVIPList",params)
// /编辑会员卡开启关闭状态
export const UpdateVIPCardStatus = params =>post("/VIP/VIP/UpdateVIPCardStatus",params)
///VIP/VIP/SelectVIPCardById
export const SelectVIPCardById = params =>post("/VIP/VIP/SelectVIPCardById",params)
//编辑会员卡
export const UpdateVIPCard = params =>post("/VIP/VIP/UpdateVIPCard",params)
//查询会员概况统计
export const SelectVIPStatitcs = params =>post("/VIP/VIP/SelectVIPStatitcs",params)
//查询会员概况转化率
export const SelectVIPTradeConvert = params =>post("/VIP/VIP/SelectVIPTradeConvert",params)
// 会员卡入会渠道统计
export const getVipBuyModeStatistics = params =>post("/VIP/VIP/GetVipBuyModeStatistics",params)
// 导出会员卡销售列表
export const getExportExcelForVipSalesRecord = params =>post("/VIP/VIP/ExportExcelForVipSalesRecord",params)
//查询会员卡销售列表
export const getSelectVIPSalesRecordList = params =>post("/VIP/VIP/SelectVIPSalesRecordList",params)
//查询品类列表
export const SelectBrandTypeByFirstLetter = params =>post("/bdService/BaseData/SelectBrandTypeByFirstLetter",params)
//根据选择的品类查询品牌列表
export const SelectBrandByFirstLetter = params =>post("/bdService/BaseData/SelectBrandByFirstLetter",params)
//商品列表搜索条件加载--品牌商
export const SelectBBListByCondition = params =>post("/userService/BrandBusiness/SelectBBListByCondition",params)

//商品列表搜索条件加载--品牌
export const SelectGoodsBrandByBrandType = params =>post("/bdService/BaseData/SelectGoodsBrandByBrandType",params)
//批量操作商品
export const BatchUpdateGoods = params =>post("/goodsService/Goods/BatchUpdateGoods",params)
//批量修改商品库存
export const BatchUpdateGoodsStocks = params =>post("/goodsService/Goods/BatchUpdateGoodsStocks",params)
//批量修改商品价格
export const BatchUpdateGoodsPrice = params =>post("/goodsService/Goods/BatchUpdateGoodsPrice",params)
//新增评论
export const InsertReviewReply = params =>post("/goodsService/GoodsReview/InsertReviewReply",params)
//查询回复
export const SelectReplyByReview = params =>post("/goodsService/GoodsReview/SelectReplyByReview",params)
//商品图片上传
export const UploadImgForDB = params =>post("/Upload/Upload/UploadImgForDB",params)
//批量启用/停用经销商
export const BatchUpdateBBStatus = params =>post("/ExploreShop/ExploreShop/BatchUpdateBBStatus",params,'formdata')
//批量开店/闭店经销商
export const BatchUpdateBBIsOpenShop = params =>post("/ExploreShop/ExploreShop/BatchUpdateBBIsOpenShop",params,'formdata')
//批量认证/取消认证经销商
export const BatchUpdateBBIIsCertificateShop = params =>post("/ExploreShop/ExploreShop/BatchUpdateBBIIsCertificateShop",params)
//批量设置合作模式
export const BatchUpdateBBCooperationType = params =>post("/ExploreShop/ExploreShop/BatchUpdateBBCooperationType",params)
//问答设为精华
export const UpdateQ_AEssence = params =>post("QuestionsManage/UpdateQ_AEssence",params)
//新增/编辑问题
export const EditQuestion = params =>post("/QuestionsManage/EditQuestion",params)
//回答列表查询
export const SelectAnswerByQId = params =>post("QuestionsManage/SelectAnswerByQId",params)
//新增/编辑回答
export const EditAnswer = params =>post("QuestionsManage/EditAnswer",params)
//删除回答
export const DeleteAnswer = params =>post("QuestionsManage/DeleteAnswer",params)
//批量操作商品可用优惠券
export const BatchUpdateGoodsIsUseCoupon = params =>post("/goodsService/Goods/BatchUpdateGoodsIsUseCoupon",params)
// /批量操作商品可享受会员折扣
export const BatchUpdateGoodsIsApplyVIPDiscount = params =>post("/goodsService/Goods/BatchUpdateGoodsIsApplyVIPDiscount",params)
//查询栏目列表
export const SelectGoodsColumnListByCondition = params =>post("/GoodsColumn/GoodsColumn/SelectGoodsColumnListByCondition",params)
//批量删除栏目
export const DeleteGoodsColumn = params =>post("/GoodsColumn/GoodsColumn/DeleteGoodsColumn",params)
//批量开启/关闭栏目
export const OpenOrCloseGoodsColumn = params =>post("/GoodsColumn/GoodsColumn/OpenOrCloseGoodsColumn",params)
//修改栏目排序序号
export const UpdateGoodsColumnSortNumber = params =>post("/GoodsColumn/GoodsColumn/UpdateGoodsColumnSortNumber",params)
//新增/编辑栏目
export const EditGoodsColumn = params =>post("/GoodsColumn/GoodsColumn/EditGoodsColumn",params)
//查询栏目商品
export const SelectGCGoodsList = params =>post("GoodsColumn/GoodsColumn/SelectGCGoodsList",params)
//查询栏目可添加的商品列表
export const SelectGoodsAvalibleByCOndition = params =>post("GoodsColumn/GoodsColumn/SelectGoodsAvalibleByCOndition",params)
//新增栏目商品
export const InsertGCGoods = params =>post("GoodsColumn/GoodsColumn/InsertGCGoods",params)
//批量删除栏目商品
export const DeleteGCGoods = params =>post("/GoodsColumn/GoodsColumn/DeleteGCGoods",params)
//查询活动列表
export const SelectRegionOfflineActiveByCondtion = params =>post("/RegionOfflineActive/SelectRegionOfflineActiveByCondtion",params)
//查询活动的报名记录
export const SelectROASignRecordByRoaId = params =>post("/RegionOfflineActive/SelectROASignRecordByRoaId",params)
//开启/关闭活动
export const UpdateROAStatusByIdAndStatusId = params =>post("/RegionOfflineActive/UpdateROAStatusByIdAndStatusId",params)

// 活动管理-新增-生成Guid
export const getCreateGUID = params =>post("/RegionOfflineActive/CreateGUID",params)
// 活动管理-编辑/查看，根据活动ID查询活动信息
export const getSelectRegionOfflineActiveById = params =>post("/RegionOfflineActive/SelectRegionOfflineActiveById",params)
// 新增/编辑页面-活动商品-新增参展商品
export const SelectGoodsByCityId = params =>post("/RegionOfflineActive/SelectGoodsByCityId",params)
// 添加参展商品
export const AddGoods = params =>post("/RegionOfflineActive/AddGoods",params)
// 查询已添加的活动商品
export const SelectROAGoods = params =>post("/RegionOfflineActive/SelectROAGoods",params)
// 删除参展商品
export const DeleteGoods = params =>post("/RegionOfflineActive/DeleteGoods",params)
// 修改活动商品顺序 向上 向下
export const UpdateGoodsOrderNum = params =>post("/RegionOfflineActive/UpdateGoodsOrderNum",params)

// 新增/编辑页面-活动品牌-新增参展品牌
export const getSelectGoodsBrandByBrandType = params =>post("RegionOfflineActive/SelectGoodsBrandByBrandType",params)
// 添加参展品牌
export const AddBrands = params =>post("/RegionOfflineActive/AddBrands",params)
// 查询已添加的活动品牌
export const SelectROABrands = params =>post("/RegionOfflineActive/SelectROABrands",params)
// 删除活动品牌
export const DeleteBrands = params =>post("/RegionOfflineActive/DeleteBrands",params)
// 修改已参展活动品牌的顺序 向上 向下
export const UpdateBrandsOrderNum = params =>post("/RegionOfflineActive/UpdateBrandsOrderNum",params)
// 新增保存
export const InsertRegionOfflineActive = params =>post("/RegionOfflineActive/InsertRegionOfflineActive",params)
// 修改保存
export const UpdateRegionOfflineActive = params =>post("/RegionOfflineActive/UpdateRegionOfflineActive",params)
// 批量上传图片,拖拽接口
export const BatchUpdateImgSortNumber = params =>post("/goodsService/Goods/BatchUpdateImgSortNumber",params);

// 订单管理
export const SelectOrderList = params => post("/OrderLiteration/OrderLiteration/SelectOrderList", params);
// 查询订单详情
export const SelectOrderDetailById = params => post("/OrderLiteration/OrderLiteration/SelectOrderDetailById", params);
// 后台取消订单
export const CancelOrderForBackground = params =>post("/OrderLiteration/OrderLiteration/CancelOrderForBackground",params);
// 后台订单发货
export const UpdateOrderLogisticsInfo = params =>post("/OrderLiteration/OrderLiteration/UpdateOrderLogisticsInfo",params);

// 售后管理列表
export const GetAfterSaleList = params =>post("/Order/AfterSaleManage_BMP/GetAfterSaleList",params);
// 售后管理查询区域类型+状态
export const getSelectAfterSaleTypeAndStatus = params =>post("/Order/AfterSaleManage_BMP/SelectAfterSaleTypeAndStatus",params);
// 后台售后详情
export const GetAfterSaleDeatil = params =>post("/Order/AfterSaleManage_BMP/GetAfterSaleDeatil",params);
// 后台售后审核
export const AfterSelaWork_Audit = params =>post("/Order/AfterSaleManage_BMP/AfterSelaWork_Audit",params);
// 后台售后退款
export const AfterSelaWork_BackMoney = params =>post("/Order/AfterSaleManage_BMP/AfterSelaWork_BackMoney",params);
// 后台售后确认收货
export const AfterSelaWork_Confirm = params =>post("/Order/AfterSaleManage_BMP/AfterSelaWork_Confirm",params);
// 后台售后商家发货
export const AfterSelaWork_SendGoods = params =>post("/Order/AfterSaleManage_BMP/AfterSelaWork_SendGoods",params);

// 查询会员卡列表
export const getSelectVIPList = params =>post("/VIP/VIP/SelectVIPList",params);
// 编辑会员卡
export const getUpdateVIPCard = params =>post("/VIP/VIP/UpdateVIPCard",params);
// 查询会员卡详情
export const getSelectVIPCardById = params =>post("/VIP/VIP/SelectVIPCardById",params);
// 添加合作品牌
export const getAddCooperatePartner = params =>post("/VIP/VIP/AddCooperatePartner",params);
// 批量删除合作品牌
export const deleteCooperatePartner = params =>post("/VIP/VIP/DeleteCooperatePartner",params);
// 查询会员卡合作店铺列表
export const getSelectBrandBusinessListByBrandIdAndCityIdsExceptBeenSelected = params =>post("/VIP/VIP/SelectBrandBusinessListByBrandIdAndCityIdsExceptBeenSelected",params);
// 选择城市事件
export const getSelectCCPByCity = params =>post("/VIP/VIP/SelectCCPByCity",params);

// 查询会员交易记录列表--平台
export const getTradeRecordsListForPlatformByCondition = params =>post("/VIP/VIPTradeRecordManagement/GetTradeRecordsListForPlatformByCondition",params);
// 平台修改会员交易记录是否已结算
export const getUpdateVIPTradeOrderPlatformIsSettlement = params =>post("/VIP/VIPTradeRecordManagement/UpdateVIPTradeOrderPlatformIsSettlement",params);
// 查询会员交易记录详情
export const getTradeRecordOrderDetailById = params =>post("/VIP/VIPTradeRecordManagement/GetTradeRecordOrderDetailById",params);

// 生成品牌商绑定金专微信小程序推广二维码
export const getGoldenCardWxQRCode = (params, headers) =>post("/wxService/QRCode/GetGoldenCardWxQRCode",params, headers);

// 查询全部省+市
export const getProvinceAndCityAndZoneByDataType = params =>post("/bdService/BaseData/GetAdministrativeList",params)

// 查询商品分析列表
export const getGoodsDataAnalysisList = params =>post("/goodsService/GoodsDataAnalysis/GetGoodsDataAnalysisList",params)
// 查询商品收藏列表
export const getGoodsCollectionRecordList = params =>post("/goodsService/GoodsDataAnalysis/GetGoodsCollectionRecordList",params)
// 查询商品浏览记录列表
export const getGoodsBrowseRecordList = params =>post("/goodsService/GoodsDataAnalysis/GetGoodsBrowseRecordList",params)
// 批量删除内容列表 & 单个删除
export const getBatchDeleteContent = params =>post("contentService/Content/BatchDeleteContent",params)

// 基础数据管理 > 品牌管理
// 查询品牌列表
export const getSelectAllBrand = params =>post("/bdService/BaseData/SelectAllBrand",params)
// 查询品牌操作记录 & 查询品类操作记录 baseDataType入参: 1 & 2
export const getSelectBaseDataOpeationLog = params =>post("/bdService/BaseData/SelectBaseDataOpeationLog",params)
// 新增品牌
export const getInsertBrand = params =>post("/bdService/BaseData/InsertBrand",params)
// 编辑品牌 根据品牌ID查询品牌信息 编辑回显接口
export const getSelectBrandInfoById = params =>post("/bdService/BaseData/SelectBrandInfoById",params)
// 修改品牌
export const getUpdateBrandById = params =>post("/bdService/BaseData/UpdateBrandById",params)

// 基础数据管理 > 品类管理
// 查询品类右侧树
export const getSelectGoodsTypeForTree = params =>post("/bdService/BaseData/SelectGoodsTypeForTree",params)
// 新增品类中的品牌
export const getInsertBrandAndTypeRelation = params =>post("/bdService/BaseData/InsertBrandAndTypeRelation",params)
// 新增品类
export const getInsertGoodsType = params =>post("/bdService/BaseData/InsertGoodsType",params)
// 修改品类
export const getUpdateGoodsType = params =>post("/bdService/BaseData/UpdateGoodsType",params)
// 查询二级品类未关联的品牌
export const getSelectBrandNotByGoodsTypeId = params =>post("/bdService/BaseData/SelectBrandNotByGoodsTypeId",params)
// 根据二级品类查询品类关联的品牌
export const getSelectBrandByGoodsTypeId = params =>post("/bdService/BaseData/SelectBrandByGoodsTypeId",params)
// 删除品类下的指定品牌
export const getDeleteBrandTypeRelation = params =>post("/bdService/BaseData/DeleteBrandTypeRelation",params)

// banner拖动排序
export const getUpdateBannerDisplayOrder = params =>post("/Banner/BannerManage/UpdateBannerDisplayOrder",params)

// 根据商品品类查询商品参数列表
export const getGetGoodsParameterList = params =>post("/bdService/BaseData/GetGoodsParameterList",params)
// 新增商品参数列表
export const getAddGoodsParameters = params =>post("/bdService/BaseData/AddGoodsParameters",params)
// 删除商品参数列表
export const getRemoveGoodsParameters = params =>post("/bdService/BaseData/RemoveGoodsParameters",params)
// 编辑商品参数列表
export const getUpdateGoodsParameters = params =>post("/bdService/BaseData/UpdateGoodsParameters",params)

// 查询代购单列表
export const getUserPurchasingByConditionForList = params =>post("/Purchasing/Purchasing/GetUserPurchasingByConditionForList",params)
// 查询代购单详情
export const getUserPurchasingDetailById = params =>post("/Purchasing/Purchasing/GetUserPurchasingDetailById",params)
// 修改代购最终价格，并上传代购合同
export const getUpdatePurchasingStatusByUploadContract = params =>post("/Purchasing/Purchasing/UpdatePurchasingStatusByUploadContract",params)

// 查询客户询价单列表
export const getSelectInquiryByCondition = params =>post("/Inquiry/BrandBusinessInquiry/SelectInquiryByCondition",params)
// 查询询价单详情
export const getSelectInquiryById = params =>post("/Inquiry/BrandBusinessInquiry/SelectInquiryById",params)
// 提交报价单
export const getSubmitQuotation = (params, headers) =>post("/Inquiry/BrandBusinessInquiry/SubmitQuotation",params, headers)
// 查询报价记录
export const getSelectQuotationByInquiryIdAndUserId = params =>post("/Inquiry/BrandBusinessInquiry/SelectQuotationByInquiryIdAndUserId",params)
// 发送商家报价
export const getSendQuote = params =>post("/Inquiry/BrandBusinessInquiry/SendQuote",params)
// 查询佣金比例
export const getSelectCommisionRateByUserIDAndBrandId = params =>post("/Inquiry/BrandBusinessInquiry/SelectCommisionRateByUserIDAndBrandId",params)
// 修改报价单
export const getUpdateQuotation = (params, headers) =>post("/Inquiry/BrandBusinessInquiry/UpdateQuotation",params, headers)

// 查询共创端
export const getSelectCoCreationEnderManage = params =>post("/userService/CoCreationEnderManage/SelectCoCreationEnderManage",params)
// 查询共创端引流列表
export const postyljl = params =>post("/userService/CoCreationEnderManage/GetCoCreationDrainageListByCoCreationUserId",params)
// 生成共创端推广二维码
export const getGenGoldCCInvitationQrCode = params =>post("/wxService/QRCode/GenGoldCCInvitationQrCode",params)
// 设置共创端佣金比例
export const getUpdateCoCreationEnderRate = params =>post("/userService/CoCreationEnderManage/UpdateCoCreationEnderRate",params)

// 修改品牌商排序
export const getUpdateBrandBusinessDisplayOrder = params =>post("userService/BrandBusiness/UpdateBrandBusinessDisplayOrder",params)

// 查询渠道推广列表
export const getChannelPromotionList = params =>post("/JZVIPCard/VipCardChannelPromotion/GetChannelPromotionList",params)
// 新增推广渠道
export const getInsertChannelPromotion = params =>post("/JZVIPCard/VipCardChannelPromotion/InsertChannelPromotion",params)
// 修改推广渠道
export const getUpdateChannelPromotion = params =>post("/JZVIPCard/VipCardChannelPromotion/UpdateChannelPromotion",params)
// 修改推广渠道开启/禁用状态
export const getUpdateChannelPromotionStatus = params =>post("/JZVIPCard/VipCardChannelPromotion/UpdateChannelPromotionStatus",params)
// 生成推广渠道二维码
export const getGeneratedChannelPromotionQrCode = params =>post("/wxService/QRCode/GeneratedChannelPromotionQrCode",params)

// 查询待审核退单列表
export const getReturnOrderReviewingList = params =>post("/OrderLiteration/OrderLiteration/GetReturnOrderReviewingList",params)
// 审核退单
export const getReviewChargeBack = params =>post("/OrderLiteration/OrderLiteration/ReviewChargeBack",params)

// 后台根据橱窗商品id查询品牌店铺商品详情
export const getMerchantShopWindowGoodsDetailByGoodsId = params =>post("/JZVIPCard/MerchantShopForBlackGoldCard/GetMerchantShopWindowGoodsDetailByGoodsId",params)
// 查询品牌商代理的品类品牌列表
export const getMerchantGoodsBrandTypeList = params =>post("/JZVIPCard/MerchantShopForBlackGoldCard/GetMerchantGoodsBrandTypeList",params)

// 所属品牌+三级级联
export const getBrandBusinessListExceptBeenSelected = params =>post("/VIP/VIP/GetBrandBusinessListExceptBeenSelected",params)





// WEBPACK FOOTER //
// ./src/api/api.js